import { Component, OnInit, ViewChild } from '@angular/core';
import {
  CropperSettings,
  ImageCropperComponent,
  Bounds,
} from 'ngx-img-cropper';
import {
  ModalSize,
  SuiModalService,
  TemplateModalConfig,
  ModalTemplate,
} from '@richardlt/ng2-semantic-ui';
import { Subject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/modules/core/services';
import { OrganizationService } from 'src/modules/features/admin/services';
import { UserService } from 'src/modules/features/public/services';
import {
  CompanyNameModal,
  CompanyDetailModal,
  CompanyInfoModal,
  CompanyPictureModal,
  NewTccRecordModal,
} from 'src/modules/features/contractor/modals';
import { DashboardProvider } from '../../../services';
import { toTypeScript } from '@angular/compiler';
import { CompanyDetailViewModal } from '../../../modals/company-detail-view-modal/company-detail-view-modal.component';
import { EditCompanyDetailModal } from '../../../modals/edit-company-detail-modal/edit-company-detail-modal.component';
import { ViewHistoryModal } from '../../../modals/view-history-modal/view-history-modal.component';
import { EditCompanyCeoInfoModal } from '../../../modals/edit-company-ceo-info-modal/edit-company-ceo-info-modal.component';
import { EditOtherTccModal } from '../../../modals/edit-other-tcc-modal/edit-other-tcc-modal.component';
@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss'],
})
export class CompanyProfileComponent implements OnInit {
  unsubscribe$: Subject<boolean> = new Subject();
  @ViewChild('cropper') cropper: ImageCropperComponent;
  @ViewChild('uploadTemplate') public modalTemplate: ModalTemplate<
    any,
    string,
    string
  >;
  @ViewChild('organizationProfileTemplate')
  public organizationProfileModal: ModalTemplate<any, string, string>;
  success: any;
  error: any;
  pending: boolean;
  filter: AppFilter = new AppFilter();
  organization: any;
  companyCEOInfo;
  user;
  cropperSettings: CropperSettings;
  mode = 'date';
  record;
  isCorrect: string = 'true';
  validationKey;
  data = { image: 'assets/avatar/1.jpg' };
  verifyUser: boolean = false;
  permissions: any[];
  baseUrl = environment.API_SERVER;
  companyDetail;
  status: Object;
  rcStatus: string;
  addressStatus: string;
  tinStatus: string;
  otherTinStatus: string;
  contactStatus: string;
  nameStatus: string;
  message;
  redirect_url;
  applicationType;
  isMda: boolean = false;

  companyType;
  isBusinessName: boolean = false;

  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private authSvc: AuthenticationService,
    private organizationSvc: OrganizationService,
    private userSvc: UserService,
    private dashboardSvc: DashboardProvider,
    private router: Router
  ) {
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.companyType = this.organization?.jpaContractor?.companyType?.optionId;
    this.getCompanyType();

    this.companyCEOInfo = {
      ceoName: this.organization?.jpaContractor?.ceoName,
      ceoContactEmail: this.organization?.jpaContractor?.ceoContactEmail,
      ceoContactPhone: this.organization?.jpaContractor?.ceoContactPhone,
      nccId: this.organization?.jpaContractor?.nccId,
    };
    if (this.organization.organizationTypeId.organizationTypeId === 'mda') {
      this.isMda = true;
    }
    console.log(this.companyCEOInfo, 'this.companyCEOInfo');
    this.user = JSON.parse(window.localStorage.getItem('user'));
    this.message = window.localStorage.getItem('message');
    this.applicationType = window.localStorage.getItem('application_type');
    this.redirect_url = window.localStorage.getItem('redirect_url');
    if (this.organization && this.organization.logoPath) {
      this.data.image = `${
        this.baseUrl
      }/public/image/?media=${this.organization.logoPath.replace(/\\/g, '/')}`;
    } else {
      this.data = { image: 'assets/avatar/1.jpg' };
    }
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.noFileInput = true;
    this.cropperSettings.width = 380;
    this.cropperSettings.height = 300;

    this.cropperSettings.croppedWidth = 190;
    this.cropperSettings.croppedHeight = 150;

    this.cropperSettings.canvasWidth = 240;
    this.cropperSettings.canvasHeight = 140;

    // this.activatedRoute.parent.params.subscribe((params) => {
    // 	// this.projectId = params['id'];
    // });
    this.getVerificationStatus();
    this.getRecord();
  }

  getCompanyType() {
    // let companyType = this.organization?.jpaContractor?.companyType?.optionId;
    if (
      this.companyType === 'business_name_actual' ||
      this.companyType === 'business_name'
    ) {
      this.isBusinessName = true;
    }
  }

  getOrganizationDetails() {
    this.organizationSvc
      .getContractor({
        organizationId: this.organization.organizationId,
      })
      .subscribe(
        (res: any) => {
          window.localStorage.setItem('organization', JSON.stringify(res));
          this.organization = res;
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getRecord() {
    this.pending = true;
    this.dashboardSvc.getCompanyDetail({}).subscribe(
      (res) => {
        this.companyDetail = res;
        this.companyCEOInfo = {
          ceoName: this.companyDetail
            ? this.companyDetail.ceoName
            : this.organization?.jpaContractor?.ceoName,
          ceoContactEmail: this.companyDetail
            ? this.companyDetail.ceoContactEmail
            : this.organization?.jpaContractor?.ceoContactEmail,
          ceoContactPhone: this.companyDetail
            ? this.companyDetail.ceoContactPhone
            : this.organization?.jpaContractor?.ceoContactPhone,
          nccId: this.organization?.jpaContractor?.nccId,
        };
        this.pending = false;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }

  getVerificationStatus() {
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.pending = true;
    this.dashboardSvc
      .getStatus({
        organizationId: this.organization.organizationId,
      })
      .subscribe(
        (res) => {
          this.status = res;
          this.rcStatus = res['RC_NUMBER'];
          this.addressStatus = res['ADDRESS'];
          this.tinStatus = res['TIN'];
          this.otherTinStatus = res['OTHER_TIN'];
          this.contactStatus = res['CONTACT_INFORMATION'];
          this.nameStatus = res['COMPANY_NAME'];
          this.getOrganizationDetails();
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.rcStatus = 'NOT_AVAILABLE';
          this.addressStatus = 'NOT_AVAILABLE';
          this.tinStatus = 'NOT_AVAILABLE';
          this.otherTinStatus = 'NOT_AVAILABLE';
          this.contactStatus = 'NOT_AVAILABLE';
          this.nameStatus = 'NOT_AVAILABLE';
          // this.error = error.error.errorMessage ? error.error.errorMessage
          //                                       : error.error ? error.error
          //                                       : error;
        }
      );
  }
  close() {
    this.verifyUser = false;
  }
  verifyCompany() {
    const payload = {
      nccId: this.organization['nccId'],
      userCompanyName: this.organization['userCompanyName'],
      rcNumber: this.organization['rcNumber'],
      tinNumber: this.organization['tinNumber'],
    };
    this.pending = true;
    this.userSvc
      .validateSignUpFalse({
        body: {
          nccId: '',
          rcNumber: this.organization.jpaContractor['rcNumber'],
          tinNumber: this.organization.jpaContractor['tinNumber'],
          actualCompanyType:
            this.organization.jpaContractor.actualCompanyType.optionId,
        },
      })
      .subscribe(
        (res) => {
          if (res['validationKey'] == null) {
            this.pending = false;
            this.error =
              'Verification Failed, Ensure you Provide Valid Details';
            return;
          } else {
            this.pending = false;
            this.record = res;
            this.verifyUser = true;
            this.validationKey = res;
          }
        },
        (error) => {
          this.pending = false;
          this.error = 'Error Occurred';
        }
      );
  }
  submitName(response) {
    if (this.isCorrect !== 'true') {
      this.verifyUser = false;
      this.error = 'Verification Failed, Ensure you Provide Valid Details';
      return;
    } else {
      this.verifyRecords(response);
    }
  }
  verifyRecords(item) {
    this.pending = true;
    let body = {
      validationKey: item['validationKey'],
      companyName: item.cacRecord.companyName,
    };
    this.userSvc
      .companyVerification({
        id: this.organization['organizationId'],
        body: body,
      })
      .subscribe(
        (res) => {
          this.organization.jpaContractor.actualCompanyType.optionId =
            item.cacRecord.companyType;
          this.organization.organizationShortName = item.cacRecord.companyName;
          this.organization.organizationLongName = item.cacRecord.companyName;
          window.localStorage.setItem(
            'organization',
            JSON.stringify(this.organization)
          );
          this.user.organizationId.organizationLongName =
            item.cacRecord.companyName;
          window.localStorage.setItem('user', JSON.stringify(this.user));
          this.verifyUser = false;
          this.pending = false;
          this.success = 'Contractor verified successfully';
          setTimeout(() => {
            this.getRecord();
            window.location.reload();
          }, 700);
        },
        (error) => {
          this.pending = false;
          this.error = 'Verification Failed, Ensure you Provide Valid Details';
        }
      );
  }

  popModal() {
    const config = new TemplateModalConfig<any, string, string>(
      this.modalTemplate
    );
    config.isClosable = false;
    config.transitionDuration = 200;
    config.transition = 'slide left';
    config.size = ModalSize.Tiny;
    config.isFullScreen = false;
    config.isInverted = false;
    this.modalService
      .open(config)
      .onApprove((result) => {
        this.uploadImage(this.data.image);
      })
      .onDeny((result) => {
        /* deny callback */
      });
  }

  detailCompany(event) {}
  deactivateCompany(event) {}
  serviceAccess(event) {}
  chatCompany(event) {}
  changeImage() {}
  deleteMulti() {}
  addCompany() {}

  fileChangeListener($event) {
    // console.log($event)
    const image: any = new Image();
    const file: File = $event.target.files[0];
    const myReader: FileReader = new FileReader();
    const that = this;
    myReader.onloadend = (loadEvent: any) => {
      image.src = loadEvent.target.result;
      that.cropper.setImage(image);
    };
    myReader.readAsDataURL(file);
    // that.imageDone.emit(this.data.image)
  }

  uploadImage(event) {
    this.pending = true;
    this.error = false;
    this.organizationSvc
      .uploadLogoBase({
        organizationId: this.organization.organizationId,
        body: { image: event },
      })
      .subscribe(
        (res) => {
          this.organization.logoPath = res['data'];
          this.data.image = `${this.baseUrl}/public/image/?media=${res[
            'data'
          ].replace(/\\/g, '/')}`;
          window.localStorage.setItem(
            'organization',
            JSON.stringify(Object.assign({}, this.organization))
          );
          setTimeout(() => {
            this.pending = false;
            this.success = 'Logo updated successfully';
            this.authSvc.setRefreshStorage('');
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  viewCompany(event) {}

  editName() {
    this.modalService
      .open(
        new CompanyNameModal(
          'Company Detail',
          this.organization,
          ModalSize.Tiny
        )
      )
      .onApprove((company: any) => {
        this.organization = { ...this.organization, ...company };
      })
      .onDeny(() => {});
  }

  addData() {
    this.modalService
      .open(
        new CompanyDetailModal(
          'Company Details',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove((company: any) => {
        this.organization = { ...this.organization, ...company };
      })
      .onApprove(() => {})
      .onDeny(() => {});
  }

  contactInfo() {
    this.modalService
      .open(
        new CompanyInfoModal(
          'Contact Information',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  addPicture() {
    this.modalService
      .open(
        new CompanyPictureModal(
          'Edit Picture',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  viewChangeField(event) {
    this.modalService;
    // .open(
    // 	new FieldChangeModal('Changed Field', 'Are you sure you want to delete this Lot plan?', ModalSize.Tiny)
    // )
    // .onApprove((payload) => {
    // 	// this.addWorkflowGroup(payload);
    // })
    // .onDeny(() => {});
  }

  onDelete() {}

  delete(app) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Record',
          'Are you sure you want to delete this Record?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  viewHistory(item) {
    this.modalService.open(new ViewHistoryModal('View History', item));
  }

  editDetail(val) {
    this.modalService
      .open(new EditCompanyDetailModal('Edit Detail', val))
      .onApprove((company: any) => {
        // this.organization = { ...this.organization, ...company };
        this.getVerificationStatus();
      });
  }

  newRecord(val) {
    this.modalService
      .open(new EditCompanyDetailModal('Add FIRS TIN', val, ModalSize.Mini))
      .onApprove((company: any) => {
        this.organization = { ...this.organization, ...company };
        this.getVerificationStatus();
      });
  }
  editOtherTIN(item) {
    this.modalService
      .open(
        new EditOtherTccModal(
          'Change of Other TIN',
          item,
          false,
          ModalSize.Mini
        )
      )
      .onApprove(() => {
        window.location.reload();
      })
      .onDeny(() => {});
  }

  editCompanyCEOInfo() {
    this.modalService
      .open(
        new EditCompanyCeoInfoModal(
          'Change of CEO Information',
          this.companyCEOInfo
        )
      )
      .onApprove((company: any) => {
        console.log(company, 'here');
        this.companyCEOInfo = company;
        let organization: any = JSON.parse(
          window.localStorage.getItem('organization')
        );
        const contractor = { ...organization.jpaContractor, ...company };
        organization.jpaContractor = contractor;
        window.localStorage.setItem(
          'organization',
          JSON.stringify(organization)
        );
      });
  }

  goBack() {
    this.location.back();
  }
  searchRecords(event) {}
  displayRecords(event) {}
  sortRecords(event) {}
  nextPage(event) {}
  getStatusName(nameStatus) {
    if (nameStatus == 'PENDING') return 'PENDING';
    if (
      nameStatus === 'VERIFIED' ||
      (this.companyDetail && this.companyDetail.companyRegVerified)
    ) {
      return 'VERIFIED';
    }
    if (
      nameStatus === 'NOT_AVAILABLE' ||
      (this.companyDetail && !this.companyDetail.companyRegVerified)
    ) {
      return 'NOT AVAILABLE';
    }
    if (nameStatus == 'REJECTED' || nameStatus == 'UNVERIFIED') {
      return 'UNVERIFIED';
    }
  }

  ngOnInit(): void {
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (
        event instanceof NavigationStart &&
        event.url != `/contractor/company/profile`
      ) {
        localStorage.removeItem('message');
        localStorage.removeItem('application_type');
        localStorage.removeItem('redirect_url');
      }
    });
  }
}
